export default {"src":"/_next/static/media/expand.eca3f1db.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};